import ProjectSupplier from '@/models/ProjectSupplier';
import ProjectSupplierService from '@/services/ProjectSupplierService';
import { defineStore } from 'pinia';
import { useRepo } from 'pinia-orm';

export const useCompanyProjectSupplierStore = defineStore('companyProjectSupplier', {
  state: () => ({}),

  getters: {
    models: () => useRepo(ProjectSupplier),
  },

  actions: {
    async createProjectSupplier(companyId: Id, request: ApiRequests['api.v1.company.project-supplier.store']) {
      const [data, error] = await ProjectSupplierService.company.create(companyId, request);

      if(error) {
        throw error;
      }

      this.models.save(data);

      return data;
    },

    async updateProjectSupplier(id: Id, request: ApiRequests['api.v1.company.project-supplier.update']) {
      const [data, error] = await ProjectSupplierService.company.update(id, request);

      if(error) {
        throw error;
      }

      this.models.save(data);

      return data;
    },

    async deleteProjectSupplier(id: Id) {
      const [data, error] = await ProjectSupplierService.company.delete(id);

      if(error) {
        throw error;
      }

      this.models.destroy(data.id);

      return data;
    },

    async cloneProjectSuppler(companyId: Id, request: ApiRequests['api.v1.company.project-supplier.clone']) {
      const [data, error] = await ProjectSupplierService.company.clone(companyId, request);

      if(error) {
        throw error;
      }

      this.models.save(data);

      return data;
    },
  },
});
